<template>
  <v-container fluid class="full-container catalog-container">
    <v-row class="tabs-root">
      <v-toolbar flat fixed class="tabs-toolbar">
        <v-tabs
          v-model="tab"
          grow
          show-arrows
        >
          <v-tabs-slider/>
          <v-tab :href="`#${tabs()[0]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.catalog.pages.services.icon }}</v-icon>
            {{ lang.meta.pages.catalog.pages.services.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[1]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.catalog.pages.items.icon }}</v-icon>
            {{ lang.meta.pages.catalog.pages.items.title }}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item :id="tabs()[0]">
            <Services />
          </v-tab-item>
          <v-tab-item :id="tabs()[1]">
            <Items />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Services from '@/components/catalog/services/Services'
import Items from '@/components/catalog/items/Items'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import tabs from '@/mixins/defaults/tabs'

export default {
  components: { Services, Items },
  mixins: [ appdata, utils, tabs ],
  data () {
    return {
      tabs: function () {
        return [
          this.lang.meta.pages.catalog.pages.services.path,
          this.lang.meta.pages.catalog.pages.items.path
        ]
      }
    }
  }
}
</script>

<style src="@/components/catalog/styles/index.scss" lang="scss"></style>
